<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/association-introduction">关于我们</router-link></li>
                <li class="currentNode"><a>协会章程</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>关于我们</a></li>
                    <li><router-link to="/layout/association-introduction">协会简介</router-link></li>
                    <li><router-link to=""  class="active">协会章程</router-link></li>
                    <li><router-link to="/layout/association-structure">协会构架</router-link></li>
                    <li><router-link to="/layout/join-us">申请入会</router-link></li>
                    <li><router-link to="/layout/call">联系方式</router-link></li>
                </ul>
                <div class="page-content">
                    <h3>协会章程</h3>
                    <div v-html="content"></div>
                    <p>第一章 总 则</p>
                    <p>第一条  本会的名称是：全国各省市区驻京办事处信息协会，英文名称是Information Association of Local Governments’Beijing Liaison Offices, 缩写IALB。</p>
                    <p>第二条  本会依照《社会团体登记管理条例》的规定，由各 省、自治区、直辖市、计划单列市、经济特区、省会城市、部分地(市)及大企业集团(或事业单位)驻北京办事机构自愿联合发起成立，是经国务院机关事务管理局原驻京办事处联合管理办公室(现驻京办与综合管理司)同意，经北京市社会团体登记管理机关核准登记的非营利性社会团体法人。</p>
                    <p>本协会属于联合性社会团体。</p>
                    <p>第三条 本会的宗旨是：在习近平新时代中国特色社会主义思想的指引下，团结各会员单位开发共享信息资源，服务各方经济建设。秉持“相亲相爱一家人”的理念和服务地方政府、开门办协会、资源共享的原则，搞好“四个服务”：即为各自省市区领导和职能部门科学地指导宏观经济服务；为企事业和基层单位引进技术、设备、资金、人才和经济发展服务；为促进横向经济联合服务；为加强各地方同国家政府机关、各大部、委、办和各职能机关及北京市各有关单位的纵向联系服务。</p>
                    <p>本会遵守宪法、法律、法规和国家政策，践行社会主义核心价值观，弘扬爱国主义精神，遵守社会道德风尚，恪守公益宗旨，积极履行社会责任，自觉加强诚信自律建设，诚实守信，规范发展，提高社会公信力。负责人遵纪守法，勤勉尽职，保持良好个人社会信用。</p>
                    <P>第四条 本会坚持中国共产党的全面领导，根据中国共产党章程的规定，设立中国共产党的组织，开展党的活动，为党组织的活动提供必要条件。</P>
                    <p>第五条 本会的业务主管单位是北京市发展和改革委员会，登记管理机关是北京市民政局。本会接受业务主管单位、登记管理机关的业务指导和监督管理。</p>
                    <p>第六条  本会会员分布和活动地域：北京市。</p>
                    <p>本会的住所：北京市丰台区南路1号北京云瑧金陵莲花酒店东二层8001房间。</p>
                    <p>本会的活动资金：伍万元整。</p>
                    <p>第二章 业务范围</p>
                    <p>第七条 本会的业务范围：开展各省市区驻京办事处、联络处之间联谊活动、信息交流、咨询服务、提供技术、资金、设备、人才引进服务、编辑专刊。</p>
                    <p>第八条 本会根据业务范围，开展以下活动：</p>
                    <p>(一)从国家发展战略、各区域发展核心的需要出发，有目的地搜集、整理、分析、研究、储存政策、经济、文化、科技、人才等各种信息。通过组织会员单位赴实地专题调研、向国家级 研究机构和智库购买服务、与信息服务提供商共同合作等方式挖掘信息，并及时提供给各会员单位，服务各地政府中心工作；</p>
                    <p>(二)积极组织、协调会员单位的信息工作，支持、协助会员单位在京开展各种政务服务工作；</p>
                    <p>(三)沟通地方与国家相关部委的联系，不断推进与国家相关部委信息业务的合作，建立良性双循环机制；</p>
                    <p>(四)承担本地政府领导和各职能部门委托的调研课题及协会确定的调研项目等调研活动；</p>
                    <p>(五)定期或不定期的举办信息类讲座、交流和业务技能培训工作；</p>
                    <p>(六)基本任务的实施，由各届协会班子根据实际情况，提 出具体实施方案并拟定中期和近期工作计划，积极组织督促落实。</p>
                    <p>(七)开展法律、法规、规章和协会章程规定的其它活动。</p>
                    <p>第九条 本会的活动原则</p>
                    <p>(一)按照核准的章程及业务范围开展公益性的、非营利性活动；</p>
                    <p>(二)坚持民主办会，建立民主选举、民主决策和民主管理 制度，领导机构的产生和重大事项的决策须经集体讨论，并按少数服从多数的原则作出决定；</p>
                    <p>(三)诚实守信，公正公平，不弄虚作假，不损害国家利益和会员、个人合法权益；</p>
                    <p>(四)遵循自主办会原则，工作自主，人员自聘，经费自筹；</p>
                    <p>(五)开展的业务活动，属于法律法规规章规定须经批准或者备案的事项，依法经批准或者备案后开展。</p>
                    <p>第三章 会员</p>
                    <p>第十条 本会由单位会员组成。</p>
                    <p>第十一条 符合下列条件的，可以自愿申请加入本会：</p>
                    <p>(一)拥护本会章程；</p>
                    <p>(二)有加入本会的意愿；</p>
                    <p>(三)在本会的业务领域内具有一定的影响；</p>
                    <p>(四)每个会员单位只能选派1人作为该单位的代表参加本会的会员大会；</p>
                    <p>(五)凡经国务院和北京市人民政府批准设立的驻京机构， 或在全国本行业中具有一定知名度和影响力，且社会口碑、信誉度良好的企业，承认并遵守本会章程，均可申请成为本会团体会员。</p>
                    <p>第十二条 会员入会的程序是：</p>
                    <p>(一)提交入会申请书；</p>
                    <p>(二)经一名以上会员介绍；</p>
                    <p>(三)提交有关证明材料：入会申请公函、事业单位法人证书副本复印件加盖公章；</p>
                    <p>(四)经理事会讨论通过；</p>
                    <p>(五)由理事会授权的办事机构发给会员证及协会会徽。</p>
                    <p>第十三条 会员享有下列权利：</p>
                    <p>(一)本会的选举权、被选举权和表决权；</p><p></p>
                    <p>(二)对本会工作的知情权、建议权和监督权；</p>
                    <p>(三)参加本会活动并获得服务的优先权；</p>
                    <p>(四)参加本团体的活动权；</p>
                    <p>(五)入会自愿、退会自由。</p>
                    <p>第十四条会员履行下列义务：</p>
                    <p>(一)遵守本会的章程和各项制度；</p>
                    <p>(二)执行本会的决议；</p>
                    <p>(三)维护本会的合法权益和声誉；</p>
                    <p>(四)完成本团体交办的工作；</p>
                    <p>(五)按规定交纳会费；</p>
                    <p>(六)向本会反映情况，提供有关资料。</p>
                    <p>第十五条 会员退会应书面通知本会，并交回会员证。</p>
                    <p>第十六条 会员有下列情形之一的，经理事会确认，自动丧失会员资格：</p>
                    <p>(一)一年不按规定交纳会费；</p>
                    <p>(二)一年不参加本会活动；</p>
                    <p>(三)不再符合会员条件；</p>
                    <p>(四)丧失民事行为能力。</p>
                    <p>第十七条 会员如有违反国家法律法规和本章程的行为，经理事会表决通过，给予下列处分：</p>
                    <p>(一)通报批评；</p>
                    <p>(二)暂停行使会员权利；</p>
                    <p>(三)除名。</p>
                    <p>第十八条 会员退会、自动丧失会员资格、被除名后，其在本会的会员权利、义务自行终止，并向会员公告。</p>
                    <p>会员对自动丧失会员资格、被处分决定有异议的，可以自决定之日起30日内向理事会、监事会提出申诉，必要时由理事会、监事会提交会员大会审议，申诉或者审议期间不影响决定效力。</p>
                    <p>第十九条 本会置备完整的会员名册，保存会员变化情况的证明材料，根据变化情况及时调整，并向会员公告。</p>
                    <p>第四章 组织机构</p>
                    <p>第二十条 会员大会是本会的最高权力机构。其职权是：</p>
                    <p>(一)制定和修改章程；</p>
                    <p>(二)决定本会的工作目标和发展规划；</p>
                    <p>(三)审议理事会、监事会的工作报告和财务报告；</p>
                    <p>(四)制定和修改理事、监事、负责人产生办法；</p>
                    <p>(五)选举和罢免理事、监事；</p>
                    <p>(六)制定和修改会费标准；</p>
                    <p>(七)决定设立和终止名誉职务、实体机构；</p>
                    <p>(八)决定本会名称变更事宜；</p>
                    <p>(九)决定本会终止事宜；</p>
                    <p>(十)改变或者撤销理事会、监事会不适当的决定；</p>
                    <p>(十一)决定其他重大事宜。</p>
                    <p>第二十一条 会员大会每届五年。本会召开换届会员大会6个月前，在监事会监督下，由理事会负责组织并启动换届选举工作。召开换届会员大会30日前，应将换届准备材料送至业务主 管单位和登记管理机关审查，确认符合换届条件后方可召开。因特殊情况需提前或者延期换届时，须由理事会表决通过，报业务主管单位审查并经登记管理机关批准同意，但提前或者延期换届最长不超过1年。</p>
                    <p>第二十二条 会员大会每年至少召开1次会议。会员大会须有2/3以上的会员出席方能召开，其决议须经到会会员2/3 以上表决通过方能生效。</p>
                    <p>第二十三条 理事会是会员大会的执行机构，在会员大会闭会期间领导本会开展工作，对会员大会负责。理事会与会员大会任期相同，理事至少为7人，最多不超过100人，且不超过会员的1/3,由会员大会以无记名投票方式从会员中选举产生，其退出依照产生程序。其职权是：</p>
                    <p>(一)执行会员大会的决议；</p>
                    <p>(二)筹备召开会员大会；</p>
                    <p>(三)向会员大会报告工作和财务状况；</p>
                    <p>(四)决定会员的吸收和处分，确认自动丧失会员资格；</p>
                    <p>(五)选举和罢免会长、副会长、秘书长、常务理事；</p>
                    <p>(六)决定和免除名誉职务人员；</p>
                    <p>(七)决定设立、变更和终止办事机构、分支机构、代表机构；提出设立和终止实体机构事宜，报会员大会审议；</p>
                    <p>(八)决定和免除副秘书长、各机构主要负责人；</p>
                    <p>(九)决定住所、宗旨、业务范围、活动资金、法定代表人变更，向会员大会报告、向会员公告；提出名称变更和终止事宜，报会员大会审议；</p>
                    <p>(十)领导各机构开展工作，审议其工作报告，改变或者撤销其不适当的决定；</p>
                    <p>(十一)负责换届选举工作，审议各项会议材料，提名理事、监事、负责人候选人建议人选；</p>
                    <p>(十二)审议年度工作报告、工作计划和财务预算决算；</p>
                    <p>(十三)制定内部管理制度；</p>
                    <p>(十四)处理会员的申诉，接受监事会提出的对有关问题的处理意见，制定整改措施并接受监督；</p>
                    <p>(十五)决定其他重大事项。</p>
                    <p>第二十四条  理事会每年至少召开1次会议。理事会须有 2/3 以上理事出席方能召开，其决议须经到会理事2/3 以上表决通过方能生效。</p>
                    <p>第二十五条  监事会是本会的监督机构，对会员大会负责。 监事会与会员大会任期相同，由3名监事组成，监事由会员大会以无记名投票方式从会员中选举产生，其退出依照产生程序。其职权是：</p>
                    <p>(一)选举和罢免监事长；</p>
                    <p>(二)列席理事会会议，并对决议事项提出质询或者建议；</p>
                    <p>(三)对理事、负责人和各机构主要负责人执行本会职务的行为进行监督，对严重违反本章程或者会员大会决议的人员提出有关建议；</p>
                    <p>(四)检查本会的财务报告，向会员大会报告监事会的工作和提出提案；</p>
                    <p>(五)对理事、负责人和各机构主要负责人、专职工作人员、财务管理人员损害本会利益的行为，要求其及时予以纠正；</p>
                    <p>(六)向业务主管单位、登记管理机关和党建工作机构反映本会工作中存在的问题；</p>
                    <p>(七)监督换届选举工作和届中增补、退出事项；</p>
                    <p>(八)处理会员的申诉，监督自动丧失会员资格、被处分决定；</p>
                    <p>(九)协调处理内部矛盾和争议，召集内部争议调解会议；</p>
                    <p>(十)决定其他应由监事会审议的事项</p>
                    <p>第二十六条 监事会至少半年召开一次会议。监事会会议须有2/3以上监事出席方能召开，其决议须经到会监事2/3 以上通过方为有效。</p>
                    <p>第二十七条 本会理事、负责人和各机构主要负责人、专职工作人员、财务管理人员不得兼任监事。</p>
                    <p>本会接受并支持委派监事的监督指导。</p>
                    <p>第二十八条  监事应当遵守国家法律法规和本会章程，忠实、勤勉履行职责。</p>
                    <p>第二十九条 监事会可以对本会开展活动情况进行调查，必 要时可以聘请会计师事务所等协助其工作。监事会行使职权所必需的费用，由本会承担。</p>
                    <p>第三十条 本会负责人包括会长1名、副会长4名、秘书长1名、监事长1名。上述人员任职条件为：</p>
                    <p>(一)坚持中国共产党领导，拥护中国特色社会主义制度，坚决执行党的路线、方针、政策，具备良好的政治素质；</p>
                    <p>(二)遵纪守法，勤勉尽职，个人社会信用记录良好；</p>
                    <p>(三)具备相应的专业知识、经验和能力，在本会业务(学科、专业)领域有较大影响；</p>
                    <p>(四)身体健康，能正常履责，年龄不超过70周岁，秘书长可通过选举产生，也可以聘任专职秘书长；</p>
                    <p>(五)具有完全民事行为能力，未受过剥夺政治权利的刑事处罚；</p>
                    <p>(六)能够忠实、勤勉履行职责，维护本会和会员的合法权益；</p>
                    <p>(七)无国家法律法规不得担任的其他情形。</p>
                    <p>第三十一条 本会负责人任期与理事会相同，连任不超过2届。会长、秘书长不得由同一人兼任。</p>
                    <p>第三十二条 会长可同时担任法定代表人，会长因客观原因不能担任法人的，法人也可从理事中选举产生。本会法定代表人不得兼任其他社会团体的法定代表人。法定代表人连任不超过2届。</p>
                    <p>第三十三条 担任本会法定代表人的负责人在卸任或者退出后的20日内，由本会报业务主管单位审核同意后，向登记管 理机关办理变更登记。变更登记的即日起，原任法定代表人不再履行本会法定代表人的职权。</p>
                    <p>原任法定代表人不予配合办理法定代表人变更登记的，本会可以根据理事会同意变更的决议，报业务主管单位审核同意后，向登记管理机关申请变更登记。</p>
                    <p>第三十四条  本会法定代表人履行下列职责：</p>
                    <p>(一)依照国家法律法规和本章程的规定，代表本会从事民事活动；</p>
                    <p>(二)代表本会签署有关重要文件；</p>
                    <p>(三)担任法定代表人的负责人卸任或者退出后，未在登记管理机关办理法定代表人变更登记前，应列席会员大会、理事会。</p>
                    <p>第三十五条 本会会长履行下列职责：</p>
                    <p>(一)召集和主持理事会；</p>
                    <p>(二)检查会员大会、理事会决议的落实情况；</p>
                    <p>(三)向会员大会、理事会报告工作，每年向理事会述职。</p>
                    <p>(四)会长不能履行职责时，由其提名并经理事会决议或者理事会推选1名副会长代为履行职责。</p>
                    <p>第三十六条 本会副会长、秘书长协助会长开展工作。秘书长履行下列职责：</p>
                    <p>(一)主持办事机构开展日常工作；</p>
                    <p>(二)协调各机构开展工作；</p>
                    <p>(三)向理事会报告工作；</p>
                    <p>(四)提名副秘书长及各机构主要负责人，交理事会决定；</p>
                    <p>(五)决定专职工作人员的聘用，向理事会报告；</p>
                    <p>(六)拟订年度工作报告和工作计划，报理事会审议；</p>
                    <p>(七)拟订年度财务预算决算报告，报理事会审议；</p>
                    <p>(八)拟订内部管理制度，报理事会审议。</p>
                    <p>(九)列席会员大会、理事会；</p>
                    <p>(十)处理其他日常事务。</p>
                    <p>第三十七条  本会监事长履行下列职责：</p>
                    <p>(一)召集和主持监事会；</p>
                    <p>(二)监督会员大会、理事会决议的落实情况；</p>
                    <p>(三)向会员大会、监事会报告工作。</p>
                    <p>(四)监事长不能履行职责时，由其提名并经监事会决议或者监事会推选1名监事代为履行职责。</p>
                    <p>第三十八条 本会届中理事、监事、负责人增补或者退出， 应依照换届选举的程序，召开会员大会、理事会、监事会以无记名投票方式进行。调整后，理事、监事、负责人的人数分别不超 过本章程规定的人数，并在增补或者退出后的30日内报业务主管单位和登记管理机关备案，向会员公告。</p>
                    <p>第三十九条 本会会员退会、自动丧失会员资格或者被除名的，其担任理事、监事职务权利、义务的终止，应召开会员大会表决通过；其担任负责人职务权利、义务的终止，应召开理事会、监事会表决通过，也可以在会员大会上表决通过。</p>
                    <p>第四十条 本会换届选举，届中理事、监事、负责人增补或者退出，制定和修改会费标准，所召开的会员大会、理事会、监事会会议，应采取无记名投票方式。</p>
                    <p>第四十一条 本会会议应制作会议纪要，形成决议的，应制 作书面决议，并由出席会议成员确认。会议纪要、会议决议由办 事机构至少保存10年，并以适当方式向会员通报和备查。不得以会长办公会等代替会员大会、理事会、监事会会议决议。</p>
                    <p>第四十二条 经理事会或者本会1/5以上的会员提议，可以 召开临时会员大会，会议由会长主持，会长无法主持的，由临时 会议现场表决推举1名负责人主持。经会长或者1/3 以上的理事，可以分别召开临时理事会会议，会议由会长主持，会长无法主持的，由临时会议现场表决推举1名负责人主持。经监事长或者 1/3 以上的监事提议，可以召开临时监事会会议，会议由监事长 主持，监事长无法主持的，由临时会议现场表决推举1名监事主持。临时会议出席及表决人数须符合本章程规定的法定人数要 求。召开临时会议，须以有效方式通知所有应参会人员参会，拒不参会的视为放弃权利。</p>
                    <p>第四十三条 本会设办事机构秘书处，在理事会领导下处理本会日常事务性工作，对理事会负责。</p>
                    <p>第四十四条  本会在章程规定的宗旨和业务范围内，根据工作需要设立分支机构、代表机构，并对设立的必要性、可行性进行充分论证，对设立的条件进行严格审查，主动征求业务主管单位意见，自觉接受业务主管单位监管。分枝机构、代表机构的名称要符合有关法律、法规的要求，并有利于开展工作方便，并经理事会研究同意后设置。</p>
                    <p>分支机构、代表机构是本会的组成部分，不具有法人资格，不另行制定章程，不发放登记证书，不设立地域性分支机构，不在分支机构、代表机构下再设立分支机构、代表机构，在本会授权的范围内开展活动、发展会员，财务纳入本会法定账户统一管理，法律责任由本会承担。</p>
                    <p>分支机构、代表机构的负责人由理事会研究同意后以聘任的方式任命。</p>
                    <p>第四十五条  本会举办实体机构，须经理事会研究后，提交会员大会表决通过，其经营范围须与本章程规定的宗旨和业务范围相适应。</p>
                    <p>本会在资产、机构、人员等方面与所举办实体机构分开，与 实体机构之间发生经济往来，按照等价交换的原则收取价款、支付费用。</p>
                    <p>本会加强对实体机构财务情况的监督，定期向会员大会、理事会、监事会报告相关情况。</p>
                    <p>第四十六条 本会建立健全内部管理制度，并严格按照内部 管理制度运行管理。本会法人登记证书、印章、财务凭证、对外 签署的各类合同等保存在办事机构，办事机构须严格执行制度进 行管理。理事会、监事会依据决议要求办事机构提供的，办事机构应无条件配合。</p>
                    <p>第五章  党建工作</p>
                    <p>第四十七条 本会拥护和支持党组织发挥政治核心作用，引 导和监督本会依法执业、诚信从业，教育引导职工群众增强政治 认同，引导和支持本会有序参加社会治理、提供公共服务、承担社会责任。</p>
                    <p>第四十八条 本会暂不具备单独建立党组织条件，通过建立 联合党组织或者由上级党组织选派党建工作指导员等方式，在本会开展党的工作。</p>
                    <p>本会负责人中有党员的，优先推荐党员负责人担任党组织书 记；负责人中没有党员的，推荐业务能力强、群众基础好的党员理事或者监事担任党组织书记。</p>
                    <p>第四十九条  本会邀请党组织负责人参加或者列席理事会 等会议，听取党组织对重要事项决策、重要业务活动、大额经费开支、接收大额捐赠、开展涉外活动等的意见。</p>
                    <p>第五十条 本会为党组织开展活动、做好工作提供必要的场地、人员和经费支持。</p>
                    <p>第五十一条 本会支持建立工会、共青团、妇联组织，做好联系职工群众等工作。</p>
                    <p>第六章 资产管理</p>
                    <p>第五十二条 本会收入来源：</p>
                    <p>(一)会费；</p>
                    <p>(二)接受捐赠；</p>
                    <p>(三)政府资助；</p>
                    <p>(四)在核准的业务范围内开展活动、提供服务的收入；</p>
                    <p>(五)利息。</p>
                    <p>(六)其他合法收入。</p>
                    <p>第五十三条  本会按照国家有关规定和会员大会制定或者修改的会费标准收取会员会费。</p>
                    <p>本会开展评比达标表彰活动不收取任何费用。</p>
                    <p>第五十四条  本会的收入及其使用情况向会员大会、理事会、监事会公布，接受监督检查。</p>
                    <p>本会接受境外捐赠与资助时，在30天内将接受捐赠与资助及使用的情况向业务主管单位和登记管理机关报告。接受境外非 政府组织的捐赠与资助时，同时按照相关法律规定向公安部门备案。</p>
                    <p>第五十五条  本会合法取得的收入除用于与本会有关的、合理的支出外，全部用于本章程规定的业务范围和非营利事业。</p>
                    <p>第五十六条 本会的全部资产及其增值为本会所有，任何单位、个人不得侵占、私分和挪用，也不得在会员中分配。</p>
                    <p>发起人或者资助人对投入本会的财产不保留或者享有任何财产权利。</p>
                    <p>第五十七条 本会的财产及其孳息不得在发起人、理事、监事、负责人和会员中进行分配，但不包括合理的工资薪金支出。</p>
                    <p>本会专职工作人员的工资、福利待遇等开支控制在规定的合理比例内，具体由理事会按照国家相关政策规定制定执行。</p>
                    <p>第五十八条  本会执行《民间非营利组织会计制度》,建立严格的财务管理制度，保证会计资料合法、真实、准确、完整。</p>
                    <p>第五十九条 本会配备具有专业资格的会计人员。会计不得 兼任出纳。会计人员必须进行会计核算，实行会计监督。会计人员调动工作或者离职时，须与接管人员办清交接手续。</p>
                    <p>第六十条 本会开展保值增值投资活动的重大投资方案，投资金额20万以下的，提交理事会审议；投资金额超过20万元的提交会员大会审议，并须经2/3 以上组成人员同意。</p>
                    <p>第六十一条 本会的资产管理执行国家规定的财务管理制度，接受会员大会、监事会和税务、会计主管部门依法实施的监 督。资产来源属于政府拨款或者社会捐赠、资助的，接受审计部门的监督，并将有关情况以适当方式向社会公布。</p>
                    <p>第六十二条  本会换届或者法定代表人离任之前，选择有资质的会计师事务所进行财务审计。</p>
                    <p>第六十三条  本会不为其他单位、组织或者个人提供任何形式的担保，不开展承担无限连带责任的投资活动。</p>
                    <p>第六十四条  本会理事会决议违反国家法律法规或者本章 程规定，致使本会遭受损失时，参与审议的理事应承担责任，但经证明在表决时反对并记载于会议记录的，该理事可免除责任。</p>
                    <p>本会负责人未经授权且未履行民主决策程序进行的保值增值投资活动等，给本会造成损失的，须承担个人责任。</p>
                    <p>第七章 年度检查(报告)及信息公开</p>
                    <p>第六十五条 本会每年3月31日前向业务主管单位报送上一年度的工作报告，经业务主管单位初审同意后，于5月31日前报送登记管理机关，接受年度检查。</p>
                    <p>第六十六条  本会建立重大事项报告制度，工作中的重大事件、开展的重大活动、对社会可能产生的重大影响等，及时向业务主管单位和登记管理机关报告。</p>
                    <p>第六十七条  本会依法履行信息公开义务，建立信息公开制度，及时向会员公开年度工作报告、第三方机构出具的报告、会费收支、有关会议纪要、内部管理制度等，以及经理事会研究认 为有必要公开的其他信息；及时向社会公开登记事项、章程、组 织机构、会费、接受捐赠、信用承诺、承接政府委托事项、可提供服务事项等信息。</p>
                    <p>第八章  争议解决</p>
                    <p>第六十八条 本会建立内部争议解决机制。内部相关方之间如发生矛盾和纠纷，按照相关方沟通、理事会协调、监事会调解、会员大会审议的顺序依次推进协商解决。</p>
                    <p>第六十九条 本会建立内部争议调解会议制度。</p>
                    <p>第七十条 无法协商处理时，相关方可以向人民调解组织、 第三方调解机构申请调解。仍无法调解或者对调解不服时，相关 方可以依照《民事诉讼法》的规定，向人民法院提起诉讼，其中劳动争议应先向劳动争议仲裁委员会申请仲裁。</p>
                    <p>第七十一条 本会成员如发现理事、监事、负责人存在违法犯罪行为，可以向司法机关举报，对侵犯其人身、财产权利的可以向司法机关控告。</p>
                    <p>第九章  章程修改</p>
                    <p>第七十二条 本会章程的修改，由理事会表决同意，提前 30日报业务主管单位和登记管理机关预审核后，提交会员大会表决通过，并报业务主管单位审查同意，在30日内报登记管理机关核准。</p>
                    <p>第十章 终止程序</p>
                    <p>第七十三条 本会完成宗旨、自行解散等原因需要注销时， 由理事会提出终止动议，经会员大会表决通过，并报业务主管单位审查同意。</p>
                    <p>第七十四条  本会决定解散、被撤销或者吊销的，应当在业务主管单位指导下成立清算组，清理债权债务，处理善后事宜。</p>
                    <p>清算期间，不开展清算以外的活动。</p>
                    <p>本会的理事、监事、负责人为清算义务人。清算义务人未及时履行清算义务，造成损害的，应承担民事责任。</p>
                    <p>本会未及时组建清算组的，理事、监事、负责人可以申请人民法院指定有关人员组成清算组进行清算。清算组的职权和程序参照有关法律的规定。</p>
                    <p>第七十五条 本会经登记管理机关办理注销登记手续后即为终止。</p>
                    <p>第七十六条  本会终止后的剩余财产，在业务主管单位和登 记管理机关的监督下，按照国家有关规定，用于发展与本会宗旨相关的公益事业，或者捐赠给宗旨相近的社会组织。</p>
                    <p>第十一章  附则</p>
                    <p>第七十七条  本章程经2024年3月6日第八届第二次会员大会表决通过。</p>
                    <p>第七十八条  本章程的解释权属本会理事会。</p>
                    <p>第七十九条  本章程自登记管理机关核准之日起生效。</p>               
                
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import {
    getXiehuiModel,
} from '@services/indexService.js'
export default {
    name:"",
    data() {
        return {
            id: 5, // 5
            content: "",
        }
    },
    created() {
    },
    methods: {
        getXiehuiModel() {
            let params = {
                id: this.id
            };
            getXiehuiModel(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.content = res.Data.Industry;
                } else {
                    this.content = "";
                    this.$message.error("协会简介请求失败");
                }
            })
        }
    }
}
</script>

<style scoped>
.page-content {
    padding: 30px;
}
.page-content h3{
    text-align:center;
}
.page-content p {
    font-family: 思源黑体 CN;
    font-size: 16px;
    line-height: 28.64px;
    color: #4E5969;
    margin-bottom: 20px;
    width: 100%;
    /* text-indent: 2em; */
}
</style>